/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { withRouter } from 'react-router';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import { Button } from 'react-bootstrap';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { useDispatch, useSelector } from 'react-redux';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import {
  getRebateProgramCode,
  setCreateUtilTapeData,
  calculateUtilization,
  listCmsReportGroups,
  getRebateProgramByCMSReportGrp,
  setErrorMessagesData,
  updateQuarter,
  dispatchRebateProgByCMSReportGrp,
  setCMSReportingGrps,
  getMaxQuarterForFreezeDt,
} from '../Store/actions';
import { getUserDefaults } from '../../../System/UserDefault/store/actions';
import {
  REBATE_PROGRAM_REQUIRED,
  QUARTER_VALUE_REQUIRED,
  VALIDATE_QUARTER_VALUE,
  REBATE_REPORTING_REQUIRED,
} from '../../../../SharedModules/Errors/constantMessageData';
import {
  handleScrollToEvent,
  quarterTest1,
  quarterTest2,
  checkQuarterValidation,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import * as CONSTANTS from '../../../../SharedModules/AppConstants';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import { getMaxQtrEnroll } from '../../../Maintain/RebateProgram/MaintainRebate/store/actions';
import {
  autoFormateDate,
  tabHighLigther,
} from '../../../../SharedModules/utilities/utilities';
import GroupOfRebateProgramComponent from '../../../../SharedModules/CustomGroupOfRebateProgram/GroupOfRebateProgramComponent';

function CreateUtilizationTape() {
  const dispatch = useDispatch();
  const [successMessages, setSuccessMessages] = useState([]);
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [runNow, setRunNow] = useState('');
  const createUtilTapeData = useSelector(
    (state) =>
      state.sharedState.CreateUtilizationTapeReducer?.createUtilTapeData
  );
  const rebateProgramCode = useSelector(
    (state) =>
      state.sharedState.CreateUtilizationTapeReducer?.rebateProgramCode?.data
  );
  const calculateInvoiceData = useSelector(
    (state) => state.sharedState.CreateUtilizationTapeReducer?.calculateInvoice
  );
  const defaultQtrCUF = useSelector(
    (state) =>
      state.sharedState.CreateUtilizationTapeReducer?.defaultQtrCUF?.data
  );
  const cmsReportingGrps = useSelector(
    (state) =>
      state.sharedState.CreateUtilizationTapeReducer?.cmsReportingGrps?.data
  );
  const rebatePrgByCMS = useSelector(
    (state) =>
      state.sharedState.CreateUtilizationTapeReducer?.rebatePrgByCMS?.data
  );
  const errorMessagesData = useSelector(
    (state) => state.sharedState.CreateUtilizationTapeReducer.errorMessages
  );
  const UserDefaultValues = useSelector(
    (state) => state.sharedState.UserDefaultReducer.UserDefaultsValues.data
  );
  const defaultRebateProgramCd = useSelector(
    (state) =>
      state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
        ?.rebateProgramCd
  );
  const max_enroll_qtr = useSelector(
    (state) => state?.sharedState?.MaintainRebateReducer?.max_enroll_qtr
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const getUserDefaultValues = (value) => dispatch(getUserDefaults(value));
  const getCmsReportGroups = (value) => dispatch(listCmsReportGroups(value));

  const getRebateProgramCodeValue = (values) => {
    dispatch(getRebateProgramCode(values));
  };

  useEffect(() => {
    if (max_enroll_qtr !== null) {
      dispatch(updateQuarter(max_enroll_qtr));
    }
  }, [dispatch, max_enroll_qtr]);
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
useEffect(() => {
    //dispatch(getMaxQtrEnroll(createUtilTapeData?.rebateProgramCd));
      getCmsReportGroups(createUtilTapeData?.quarter);

  }, [createUtilTapeData?.rebateProgramCd,createUtilTapeData?.quarter]);
  useEffect(() => {
    setSuccessMessages([]);
    getUserDefaultValues(logInUser);
    dispatch(getMaxQuarterForFreezeDt());
    dispatch(
      setCreateUtilTapeData({
        ...createUtilTapeData,
        quarter:
          createUtilTapeData?.quarter == null
            ? createUtilTapeData?.quarter
            : defaultQtrCUF,
        planType: createUtilTapeData?.planType || UserDefaultValues?.planTypeCd,
        rebateProgramCd:
          createUtilTapeData?.rebateProgramCode ||
          UserDefaultValues?.rebateProgramCd ||
          '-1',
        selectBy: createUtilTapeData.selectBy || 'single',
      })
    );
  }, []);
  // fullscreen functionality
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
    dispatch(
      setCreateUtilTapeData({
        ...createUtilTapeData,
        fullScreenView: !fullScreenView,
      })
    );
  };
  // handing highlight tab
  React.useEffect(() => {
    if (errorMessagesData?.length > 0) {
      tabHighLigther('/createUtilizationTape', true);
    } else {
      tabHighLigther('/createUtilizationTape', false);
    }
  }, [JSON.stringify(errorMessagesData)]);

  useEffect(() => {
    if (
      createUtilTapeData?.cmsReportingGrps &&
      createUtilTapeData?.cmsReportingGrps !== '-1' &&
      createUtilTapeData?.quarter
    ) {
      const rebatePrgByCMSPayload = {
        rebateProgramCode: createUtilTapeData?.cmsReportingGrps,
        quarter: createUtilTapeData?.quarter,
      };
      dispatch(getRebateProgramByCMSReportGrp(rebatePrgByCMSPayload));
    }
  }, [createUtilTapeData?.cmsReportingGrps]);

  useEffect(() => {
    if (defaultQtrCUF) {
      dispatch(
        setCreateUtilTapeData({
          ...createUtilTapeData,
          quarter:
            createUtilTapeData?.quarter == null
              ? defaultQtrCUF
              : createUtilTapeData?.quarter,
        })
      );
    }
  }, [defaultQtrCUF]);

  useEffect(() => {
    let localErr = errorMessagesData || [];
    setSuccessMessages([]);
    if (calculateInvoiceData?.status && runNow === 'N') {
      if (calculateInvoiceData?.status === '001') {
        setSuccessMessages([CONSTANTS.INVOICE_JOB_COMPLETE]);
        localErr = [];
      } else if (calculateInvoiceData?.status === '002') {
        setSuccessMessages([]);
        localErr = localErr?.filter((item) => item.field !== 'InvoiceError');
        localErr.push({
          field: 'InvoiceError',
          errorType: 'InvoiceError',
          message: calculateInvoiceData?.message,
        });
      } else {
        setSuccessMessages([]);
        localErr = localErr?.filter(
          (item) => item.field !== 'ERR_PROCESSING_REQ'
        );
        localErr.push({
          field: 'ERR_PROCESSING_REQ',
          errorType: 'ERR_PROCESSING_REQ',
          message: CONSTANTS.ERR_PROCESSING_REQ,
        });
      }
    } else if (calculateInvoiceData?.status && runNow === 'L') {
      if (calculateInvoiceData?.status === '001') {
        setSuccessMessages([CONSTANTS.INVOICE_JOB_DEFERED]);
        localErr = [];
      } else if (calculateInvoiceData?.status === '002') {
        setSuccessMessages([]);
        localErr = localErr?.filter((item) => item.field !== 'InvoiceError');
        localErr.push({
          field: 'InvoiceError',
          errorType: 'InvoiceError',
          message: calculateInvoiceData?.message,
        });
      } else {
        setSuccessMessages([]);
        localErr = localErr?.filter(
          (item) => item.field !== 'ERR_PROCESSING_REQ'
        );
        localErr.push({
          field: 'ERR_PROCESSING_REQ',
          errorType: 'ERR_PROCESSING_REQ',
          message: CONSTANTS.ERR_PROCESSING_REQ,
        });
      }
    } else if (calculateInvoiceData?.error === 'API failed') {
      setSuccessMessages([]);
    }
    const unique = [...new Set(localErr)];
    dispatch(setErrorMessagesData(unique));
  }, [calculateInvoiceData, runNow]);

  useEffect(() => {
    if (createUtilTapeData?.planType) {
      getRebateProgramCodeValue(createUtilTapeData?.planType);
    }
  }, [createUtilTapeData?.planType]);
  React.useEffect(() => {
    handleScrollToEvent();
  }, []);
  const fetchGroupOfRebateProgramList = (val) => {
    if (checkQuarterValidation(val)) {
      getCmsReportGroups(val);
    }
  };
  const handleCreateUtilTapeData = (e) => {
    dispatch(
      setCreateUtilTapeData({
        ...createUtilTapeData,
        [e.target.name]:
          e.target.name === 'quarter' ? e.target.value : e.target.value,
        [e.target.name]: e.target.value,
        ...('planType' in createUtilTapeData &&
          e.target.name === 'planType' && { rebateProgramCd: '-1' }),
      })
    );
  };
  const handleOnblurEvent = (type, value) => {
    let localErr = errorMessagesData || [];
    const data = value;
    if (type === 'rebateProgramCd') {
      if (!value || value === '-1') {
        localErr = localErr?.filter((item) => item.field !== 'rebateProgramCd');
        localErr.push({
          field: 'rebateProgramCd',
          errorType: 'rebateProgramCd',
          message: REBATE_PROGRAM_REQUIRED,
        });
      } else {
        localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
      }
    }
    if (type === 'cmsReportingGrps') {
      if (!value || value === '-1') {
        localErr = localErr?.filter(
          (item) => item.field !== 'cmsReportingGrps'
        );
        localErr.push({
          field: 'cmsReportingGrps',
          errorType: 'cmsReportingGrps',
          message: REBATE_REPORTING_REQUIRED,
        });
      } else {
        localErr = localErr.filter((item) => item.field !== 'cmsReportingGrps');
      }
    }
    if (type === 'quarter') {
      if (data && !_.isEmpty(data) && !_.isNaN(data)) {
        const indexOf = !_.isEmpty(localErr)
          ? _.findIndex(localErr, {
              field: 'quarter',
              errorType: 'required',
            })
          : null;

        if (!_.isNull(indexOf) && indexOf >= 0) {
          localErr.splice(indexOf, 1);
        }
        if (quarterTest1.test(data) || quarterTest2.test(data)) {
          const indexOf = !_.isEmpty(localErr)
            ? _.findIndex(localErr, {
                field: 'quarter',
                errorType: 'invalidFormat',
              })
            : null;

          if (!_.isNull(indexOf) && indexOf >= 0) {
            localErr.splice(indexOf, 1);
          }
          localErr = localErr.filter((item) => item.field !== 'quarter');
          dispatch(
            setCreateUtilTapeData({
              ...createUtilTapeData,
              [type]: value,
            })
          );
        } else {
          localErr = localErr.filter((item) => item.field !== 'quarter');
          localErr.push({
            field: 'quarter',
            errorType: 'invalidFormat',
            message: VALIDATE_QUARTER_VALUE,
          });
        }
      } else {
        localErr = localErr.filter((item) => item.field !== 'quarter');
        if (type === 'quarter') {
          localErr.push({
            field: 'quarter',
            errorType: 'required',
            message: QUARTER_VALUE_REQUIRED,
          });
        }
      }
    }

    const unique = [...new Set(localErr)];
    dispatch(setErrorMessagesData(unique));
    dispatch(
      setCreateUtilTapeData({
        ...createUtilTapeData,
        [type]: value,
      })
    );
  };
  const validateInvoiceCalcReq = () => {
    let localErr = [];
    if (createUtilTapeData?.selectBy === 'single') {
      if (
        !createUtilTapeData?.rebateProgramCd ||
        createUtilTapeData?.rebateProgramCd === '-1'
      ) {
        localErr = localErr?.filter((item) => item.field !== 'rebateProgramCd');
        localErr.push({
          field: 'rebateProgramCd',
          errorType: 'rebateProgramCd',
          message: REBATE_PROGRAM_REQUIRED,
        });
      } else {
        localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
      }
    }
    if (createUtilTapeData?.selectBy === 'group') {
      if (!(rebatePrgByCMS?.length > 0)) {
        localErr = localErr?.filter(
          (item) => item.field !== 'groupOfRebateProgram'
        );
        localErr.push({
          field: 'groupOfRebateProgram',
          errorType: 'groupOfRebateProgram',
          message: REBATE_PROGRAM_REQUIRED,
        });
      } else {
        localErr = localErr.filter(
          (item) => item.field !== 'groupOfRebateProgram'
        );
      }
      if (
        createUtilTapeData?.cmsReportingGrps === '-1' ||
        !createUtilTapeData?.cmsReportingGrps
      ) {
        localErr = localErr?.filter(
          (item) => item.field !== 'cmsReportingGrps'
        );
        localErr.push({
          field: 'cmsReportingGrps',
          errorType: 'cmsReportingGrps',
          message: REBATE_REPORTING_REQUIRED,
        });
      } else {
        localErr = localErr.filter((item) => item.field !== 'cmsReportingGrps');
      }
    }
    if (
      createUtilTapeData?.quarter &&
      !_.isEmpty(createUtilTapeData?.quarter) &&
      !_.isNaN(createUtilTapeData?.quarter)
    ) {
      const indexOf = !_.isEmpty(localErr)
        ? _.findIndex(localErr, {
            field: 'quarter',
            errorType: 'required',
          })
        : null;

      if (!_.isNull(indexOf) && indexOf >= 0) {
        localErr.splice(indexOf, 1);
      }
      if (
        quarterTest1.test(createUtilTapeData?.quarter) ||
        quarterTest2.test(createUtilTapeData?.quarter)
      ) {
        const indexOf = !_.isEmpty(localErr)
          ? _.findIndex(localErr, {
              field: 'quarter',
              errorType: 'invalidFormat',
            })
          : null;

        if (!_.isNull(indexOf) && indexOf >= 0) {
          localErr.splice(indexOf, 1);
        }
        localErr = localErr.filter((item) => item.field !== 'quarter');
      } else {
        localErr = localErr.filter((item) => item.field !== 'quarter');
        localErr.push({
          field: 'quarter',
          errorType: 'invalidFormat',
          message: VALIDATE_QUARTER_VALUE,
        });
      }
    } else {
      localErr = localErr.filter((item) => item.field !== 'quarter');
      localErr.push({
        field: 'quarter',
        errorType: 'required',
        message: QUARTER_VALUE_REQUIRED,
      });
    }
    const unique = [...new Set(localErr)];
    dispatch(setErrorMessagesData(unique));
    if (localErr.length > 0) {
      return false;
    }
    return true;
  };

  const runUtilization = (e, runFlag) => {
    setRunNow(runFlag);
    if (validateInvoiceCalcReq()) {
      let rpcGroupNo = null;
      let str = null;
      if (!_.isEmpty(rebatePrgByCMS)) {
        rpcGroupNo = rebatePrgByCMS[0]?.reportGroupNumber;
        str = rebatePrgByCMS.map((item) => {
          return item.rebateProgramCode;
        });
      }
      const reqInvoiceCalcDataPayload = {
        rpcGroupNo: createUtilTapeData?.selectBy === 'group' ? rpcGroupNo : '',
        userId: logInUser,
        runOption: runFlag,
        selectBy: createUtilTapeData?.selectBy,
        rebateProgramCode:
          createUtilTapeData?.selectBy === 'group'
            ? str?.toString()
            : createUtilTapeData?.rebateProgramCd,
        quarter: createUtilTapeData?.quarter,
      };
      dispatch(calculateUtilization(reqInvoiceCalcDataPayload));
    }
  };

  return (
    <div className="tBillPanel custom-check">
      <div className="panel tBillPanel-space devider-line pb-0">
        <Spinner load={spinnerLoader} />
        {!fullScreenView ? (
          <>
            <CustomSeparator
              parent1="Invoice"
              parent2="Create Utilization File"
            />
            <DisplaySuccessMessages successMessages={successMessages} />
            <DisplayErrorMessages
              errorMessages={[
                ...new Set(
                  errorMessagesData?.length > 0
                    ? _.map(errorMessagesData, (l) => l.message)
                    : []
                ),
              ]}
            />
            <fieldset className="custom-fieldset">
              <div className="panel mb-3">
                <div className="row">
                  <div className="col-sm-12">
                    <fieldset className="custom-fieldset">
                      <legend className="same-font-family" id="select_by_label">
                        Select by
                      </legend>
                      <div className="form-wrapper p-0 mt-2">
                        <div className="mui-custom-form input-md field-xl">
                          <div className="sub-radio no-margin">
                            <FormControl>
                              <RadioGroup
                                row
                                aria-labelledby="select_by_label"
                                name="selectBy"
                                onChange={handleCreateUtilTapeData}
                                value={createUtilTapeData?.selectBy || 'single'}
                                required
                              >
                                <FormControlLabel
                                  style={{ marginRight: '310px' }}
                                  value="single"
                                  control={<Radio />}
                                  label="Single Rebate Program"
                                  data-test="singleRbtPrg"
                                />
                                <FormControlLabel
                                  value="group"
                                  control={<Radio />}
                                  label="Group of Rebate Programs"
                                  data-test="grpRbtPrg"
                                />
                              </RadioGroup>
                            </FormControl>
                          </div>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                </div>
                {createUtilTapeData?.selectBy === 'single' ? (
                  <div className="row">
                    <div className="col-sm-12">
                      <fieldset className="custom-fieldset">
                        <legend
                          className="same-font-family"
                          id="plan_type_label"
                        >
                          Plan Type
                        </legend>
                        <div className="form-wrapper p-0 mt-2">
                          <div className="mui-custom-form input-md field-xl">
                            <div className="sub-radio no-margin">
                              <FormControl>
                                <RadioGroup
                                  row
                                  aria-labelledby="plan_type_label"
                                  name="planType"
                                  onChange={handleCreateUtilTapeData}
                                  value={createUtilTapeData?.planType}
                                  required
                                >
                                  <FormControlLabel
                                    style={{ marginRight: '240px' }}
                                    value="FD"
                                    control={<Radio />}
                                    label="Medicaid"
                                    data-test="Medicaid"
                                  />
                                  <FormControlLabel
                                    style={{ marginRight: '240px' }}
                                    value="COMM"
                                    control={<Radio />}
                                    label="Commercial"
                                    data-test="Commercial"
                                  />
                                  <FormControlLabel
                                    style={{ marginRight: '240px' }}
                                    value="ST"
                                    control={<Radio />}
                                    label="State"
                                    data-test="State"
                                  />
                                  <FormControlLabel
                                    value="SUPP"
                                    control={<Radio />}
                                    label="Supplemental"
                                    data-test="Supplemental"
                                  />
                                </RadioGroup>
                              </FormControl>
                            </div>
                          </div>
                        </div>
                      </fieldset>
                    </div>
                  </div>
                ) : null}
                <div className="row">
                  <div className="col-3">
                    <div className="mui-custom-form input-md override-width-95">
                      <TextField
                        label="Utilization Quarter"
                        fullWidth
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{ maxLength: 6 }}
                        required
                        id="quarter"
                        name="quarter"
                        value={createUtilTapeData?.quarter}
                        onChange={handleCreateUtilTapeData}
                        onBlur={(e) => {
                          handleOnblurEvent(
                            'quarter',
                            e?.target?.value?.toUpperCase()
                          );
                          fetchGroupOfRebateProgramList(e?.target?.value);
                          dispatch(
                            setCreateUtilTapeData({
                              ...createUtilTapeData,
                              quarter: autoFormateDate(
                                e?.target?.value?.toUpperCase()
                              ),
                              cmsReportingGrps: '-1',
                            })
                          );
                          dispatch(dispatchRebateProgByCMSReportGrp([]));
                          dispatch(setCMSReportingGrps([]));
                        }}
                        className={
                          errorMessagesData?.length > 0
                            ? _.map(errorMessagesData, (l) =>
                                l.field === 'quarter' ? 'mandate-fields' : null
                              )
                            : null
                        }
                        helperText={
                          errorMessagesData?.length > 0
                            ? _.map(errorMessagesData, (l) =>
                                l.field === 'quarter' ? l.message : null
                              )
                            : null
                        }
                        error={
                          errorMessagesData?.length > 0
                            ? _.map(errorMessagesData, (l) =>
                                l.field == 'quarter' ? l.message : null
                              )
                            : null
                        }
                      />
                    </div>
                  </div>
                  {createUtilTapeData?.selectBy === 'group' ? (
                    <>
                      <div className="col-4">
                        <div className="mui-custom-form with-select input-md override-width-95">
                          <TextField
                            label="CMS Reporting Group"
                            fullWidth
                            select
                            placeholder=""
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{
                              id: 'cmsReportingGrps',
                            }}
                            required
                            onChange={handleCreateUtilTapeData}
                            id="cmsReportingGrps"
                            name="cmsReportingGrps"
                            value={createUtilTapeData?.cmsReportingGrps || '-1'}
                            onBlur={(e) => {
                              let localErr = errorMessagesData || [];
                              if (!e.target.value || e.target.value === '-1') {
                                localErr = localErr?.filter(
                                  (item) => item.field !== 'cmsReportingGrps'
                                );
                                localErr.push({
                                  field: 'cmsReportingGrps',
                                  errorType: 'cmsReportingGrps',
                                  message: REBATE_REPORTING_REQUIRED,
                                });
                              } else {
                                localErr = localErr.filter(
                                  (item) => item.field !== 'cmsReportingGrps'
                                );
                              }
                              const unique = [...new Set(localErr)];
                              dispatch(setErrorMessagesData(unique));
                            }}
                            className={
                              errorMessagesData?.length > 0
                                ? _.map(errorMessagesData, (l) =>
                                    l.field == 'cmsReportingGrps'
                                      ? 'mandate-fields'
                                      : null
                                  )
                                : null
                            }
                            error={
                              errorMessagesData?.length > 0
                                ? _.map(errorMessagesData, (l) =>
                                    l.field === 'cmsReportingGrps'
                                      ? l.message
                                      : null
                                  )
                                : null
                            }
                            helperText={
                              errorMessagesData?.length > 0
                                ? _.map(errorMessagesData, (l) =>
                                    l.field === 'cmsReportingGrps'
                                      ? l.message
                                      : null
                                  )
                                : null
                            }
                          >
                            <MenuItem
                              key=""
                              value="-1"
                              className="frr-dropdown-blank-item"
                            />
                            {cmsReportingGrps?.length > 0
                              ? cmsReportingGrps.map((item) => {
                                  return (
                                    <MenuItem key={item} value={item}>
                                      {item}
                                    </MenuItem>
                                  );
                                })
                              : null}
                          </TextField>
                        </div>
                      </div>
                    </>
                  ) : null}
                  {createUtilTapeData?.selectBy === 'single' ? (
                    <div className="col-4">
                      <div className="mui-custom-form with-select input-md override-width-95">
                        <TextField
                          label="Rebate Program"
                          fullWidth
                          select
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          inputProps={{
                            id: 'rebateProgramCd',
                          }}
                          required
                          onChange={handleCreateUtilTapeData}
                          id="rebateProgramCd"
                          name="rebateProgramCd"
                          value={createUtilTapeData?.rebateProgramCd || '-1'}
                          className={
                            errorMessagesData?.length > 0
                              ? _.map(errorMessagesData, (l) =>
                                  l.field === 'rebateProgramCd'
                                    ? 'mandate-fields'
                                    : null
                                )
                              : null
                          }
                          onBlur={(e) =>
                            handleOnblurEvent(
                              'rebateProgramCd',
                              e?.target?.value
                            )
                          }
                          error={
                            errorMessagesData?.length > 0
                              ? _.map(errorMessagesData, (l) =>
                                  l.field === 'rebateProgramCd'
                                    ? l.message
                                    : null
                                )
                              : null
                          }
                          helperText={
                            errorMessagesData?.length > 0
                              ? _.map(errorMessagesData, (l) =>
                                  l.field === 'rebateProgramCd'
                                    ? l.message
                                    : null
                                )
                              : null
                          }
                        >
                          <MenuItem
                            key=""
                            value="-1"
                            className="frr-dropdown-blank-item"
                          />
                          {rebateProgramCode?.length > 0
                            ? rebateProgramCode.map((item) => {
                                return (
                                  <MenuItem
                                    key={item.rebateProgramCd}
                                    value={item.rebateProgramCd}
                                  >
                                    {item.rebateProgramCd} {'|'}{' '}
                                    {item.shortDescr}
                                  </MenuItem>
                                );
                              })
                            : null}
                        </TextField>
                      </div>
                    </div>
                  ) : null}

                  <div className="col-5 mt-4">
                    <div className="float-right mt-2 hide-on-print">
                      <Button
                        className="btn btn-success btn-save"
                        onClick={(e) => runUtilization(e, 'N')}
                      >
                        <SVGComponent iconName="Icon-run-now" /> Run Now
                      </Button>
                      <Button
                        className="btn btn-success btn-save"
                        onClick={(e) => runUtilization(e, 'L')}
                      >
                        <SVGComponent iconName="Icon-run-later" /> Run Later
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
          </>
        ) : null}
        {createUtilTapeData?.selectBy === 'group' && (
          <div className="panel-body FRR-custom-table tbl-manufacturer-inner frr-log_chk">
            <GroupOfRebateProgramComponent
              fullScreenView={fullScreenView}
              handleFullScreenView={handleFullScreenView}
              data={
                createUtilTapeData?.cmsReportingGrps !== '' &&
                createUtilTapeData?.cmsReportingGrps !== '-1'
                  ? rebatePrgByCMS?.map((item) => {
                      item.rebateProgramCd = item.rebateProgramCode;
                      item.shortDescr = item.shortDesc;
                      return item;
                    })
                  : []
              }
              fileName="G-Rebate Program Grid"
            />
          </div>
        )}
      </div>
    </div>
  );
}
export default withRouter(CreateUtilizationTape);
